import { render, staticRenderFns } from "./ImgUploadZdy.vue?vue&type=template&id=5b1328e9&"
import script from "./ImgUploadZdy.vue?vue&type=script&lang=js&"
export * from "./ImgUploadZdy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports